import React from 'react';
import { Card, Tag, Row, Col } from 'antd';

/**
 * 已选套餐模板详情卡
 * 用法：<TemplateDetailCards templateIds={[]} templateList={[]} />
 */
const TemplateDetailCards = ({ templateIds = [], templateList = [] }) => {
    if (!templateIds.length) return null;
    const selected = templateIds
        .map(id => templateList.find(t => t.id === id))
        .filter(Boolean);

    return (
        <div style={{ marginTop: 16 }}>
            <div style={{ marginBottom: 12, fontSize: 13, fontWeight: 500, color: '#666' }}>套餐模板详情</div>
            <Row gutter={[12, 12]}>
                {selected.map(t => (
                    <Col key={t.id} span={selected.length === 1 ? 24 : 12}>
                        <Card size="small" title={t.name} style={{ borderRadius: 8, height: '100%' }}>
                            <div style={{ fontSize: 12, marginBottom: 4 }}>
                                <span style={{ color: '#8c8c8c' }}>服务类型：</span>
                                <Tag color="blue" style={{ border: 'none' }}>{t.serviceType}</Tag>
                            </div>
                            {t.deviceLimit != null && (
                                <div style={{ fontSize: 12, marginBottom: 4 }}>
                                    <span style={{ color: '#8c8c8c' }}>可用设备上限：</span>
                                    <span style={{ fontWeight: 500 }}>{t.deviceLimit} 台</span>
                                </div>
                            )}
                            <div style={{ fontSize: 12, marginBottom: 8 }}>
                                <span style={{ color: '#8c8c8c' }}>平台成本：</span>
                                <span style={{ color: '#ff4d4f', fontWeight: 'bold' }}>
                                    ¥{t.costCNY != null ? (t.costCNY / 100).toFixed(2) : '-'} / ${t.costUSD != null ? (t.costUSD / 100).toFixed(2) : '-'}
                                </span>
                            </div>
                            <div style={{ fontSize: 12, color: '#8c8c8c', borderTop: '1px solid #f0f0f0', paddingTop: 8, lineHeight: 1.6 }}>
                                {t.description}
                            </div>
                        </Card>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default TemplateDetailCards;
